//This should be an API class that generalizes all API requests

import { AppEnvSetting } from "../ts/common";

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/me"
};

enum GET_ENDPOINT {
    GetEmployeeData = "GetEmployeeData",
    GetOrganizationsList = "GetOrganizationsList",
    GetRolePermission = "GetRolePermission",
    GetConfiguration = "GetConfigurationAdmin"
}

enum POST_ENDPOINT {
    AcceptApplicationAccessRequest = "AcceptApplicationAccessRequest",
    AcknowledgeNotification = "AcknowledgeNotification",
    BatchAddUser = "BatchAddUser",
    ClaimsForApps = "ClaimsForApps",
    CloseSupportRequest = "CloseSupportRequest",
    CreateUserInB2C = "CreateUserInB2C",
    DeleteEmployee = "DeleteEmployee",
    DeleteOrgFromUser = "DeleteOrgFromUser",
    DeleteUser = "DeleteUserAdmin",
    DenyApplicationAccessRequest = "DenyApplicationAccessRequest",
    EmployeeCanPerformActions = "EmployeeCanPerformActions",
    GetApplicationData = 'GetApplicationData',
    GetApplicationExternalEnumerations = 'GetApplicationExternalEnumerations',
    GetApplicationsList = 'GetApplicationsList',
    GetSCIMApplicationData = "GetSCIMApplicationData",
    GetApplicationsListForOrgs = 'GetApplicationsListForOrgs',
    GetApplicationsWithPermission = "GetApplicationsWithPermission",
    GetNotificationsForEmployee = "GetNotificationsForEmployee", 
    GetOpenSupportRequests = "GetOpenSupportRequests",
    GetOrganizationData = "GetOrganizationData",
    GetRoles = "GetRoles",
    GetUserApplicationRequests = "GetUserApplicationRequests",
    GetUserDataAdmin = "GetUserDataAdmin",  
    GetUsersWithNoLogins = "GetUsersWithNoLogins",
    Logout = "Logout",
    ResendInvite = "ResendInvite",
    ResetMFA = "ResetMFA",
    ResetUserFlags = "ResetUserFlags",
    SaveEmployeeData = "SaveEmployee",
    SaveUserApplicationData = "SaveUserApplicationData",
    SaveUserOrganizationData = 'SaveUserOrganizationData',
    SaveSCIMApplicationDataAdmin = 'SaveSCIMApplicationDataAdmin',
    SaveUserDataAdmin = "SaveUserDataAdmin",
    SearchEmployees = "SearchEmployees",
    SearchLogs = "SearchLogs",
    SearchOrganizations = "SearchOrganizations",
    SearchUsers = "SearchUsers",
    SetUserActiveStatus = "SetUserActiveStatus",
    WriteLog = "WriteLog",
    GetAllGroupsList = "GetAllGroupsList",
    GetGroupsList = "GetGroupsListAdmin",
    GetGroupData = "GetGroupDataAdmin",
    AddGroupMembers = "AddMembersToGroup",
    RemoveGroupMembers = "RemoveMembersFromGroup",
    GetGroupAccessRequests = "GetGroupAccessRequests",
    SaveUserGroupData = "SaveUserGroupData",
    ApproveGroupAccessRequest = "ApproveGroupAccessRequest",
    DenyGroupAccessRequest = "DenyGroupAccessRequest",
    WriteSupportRequest = "WriteSupportRequest",
    GetUserGroupMemberships = "GetUserGroupMemberships",
    DeleteAllOrgUsersAdmin = "DeleteAllOrgUsersAdmin"
}

enum IEF_API_POST_ENDPOINT {
  CreateSCIMApplication = "CreateSCIMApplication",
  ApplicationSecrets = "ApplicationSecrets"
}

enum IEF_API_GET_ENDPOINT {}


class API {
    //protected static ENDPOINT =  "" ;
    //every thing is POST?
    //usage: //API.POST(body, Enpoints.getNotifications);
    static POST_API = async (body: any, endpointName: POST_ENDPOINT | IEF_API_POST_ENDPOINT, token: Promise<string | undefined>, ENDPOINT: string, logging = false): Promise<{ok: boolean, status: number, respBody: any}> => {
        var accessToken = await token;

        if (accessToken === undefined || accessToken === '') {
            return {ok: false, status: -1, respBody: {}};
        }
        const API_ENDPOINT = ENDPOINT + endpointName;

        if (logging) console.log("API POST: " + API_ENDPOINT);

        var headers = new Headers();
        var bearer = "Bearer " + accessToken;
        headers.append("Authorization", bearer);

        if (logging) console.log(headers.get("Authorization"));

        const response = await fetch(API_ENDPOINT!, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        })

        try{
        const data = await response.json();
        if (logging) console.log(data);
        return {ok: response.ok, status: response.status, respBody: data};
        } catch(err) {
            return {ok: false, status: response.status, respBody: {}}
        }
    }

    static DELETE_API = async (body: any, endpointName: POST_ENDPOINT | IEF_API_POST_ENDPOINT, token: Promise<string | undefined>, ENDPOINT: string, logging = false): Promise<{ok: boolean, status: number, respBody: any}> => {
      var accessToken = await token;

      if (accessToken === undefined || accessToken === '') {
          return {ok: false, status: -1, respBody: {}};
      }
      const API_ENDPOINT = ENDPOINT + endpointName;

      if (logging) console.log("API DELETE: " + API_ENDPOINT);

      var headers = new Headers();
      var bearer = "Bearer " + accessToken;
      headers.append("Authorization", bearer);

      if (logging) console.log(headers.get("Authorization"));

      const response = await fetch(API_ENDPOINT!, {
          method: 'DELETE',
          headers: headers,
          body: JSON.stringify(body)
      })

      try{
      const data = await response.json();
      if (logging) console.log(data);
      return {ok: response.ok, status: response.status, respBody: data};
      } catch(err) {
          return {ok: false, status: response.status, respBody: {}}
      }
  }

    static GET_API = async (endpointName: GET_ENDPOINT | IEF_API_GET_ENDPOINT, token: Promise<string | undefined>, ENDPOINT: string, logging = false): Promise<{ok: boolean, status: number, respBody: any}> => {

        var accessToken = await token;

        if (accessToken === undefined || accessToken === '') {
            console.log('no token recieved from msal');
            return {ok: false, status: -1, respBody: {}};
        }

        const API_ENDPOINT = ENDPOINT + endpointName;

        if (logging) console.log("API GET: " + API_ENDPOINT);

        var headers = new Headers();
        var bearer = "Bearer " + accessToken;
        headers.append("Authorization", bearer)

        const response = await fetch(API_ENDPOINT!, {
            headers: headers
        });

        try{
            let data = await response.json();
            if (logging) console.log(data);
            return {ok: response.ok, status: response.status, respBody: data};;
            } catch(err) {
                return {ok: false, status: response.status, respBody: {}}
            }
    }

    static MSGRAPH = async (accessToken: string, logging = false) => {
        const headers = new Headers();
        const bearer = `Bearer ${accessToken}`;

        headers.append("Authorization", bearer);

        const options = {
            method: "GET",
            headers: headers
        };

        return fetch(graphConfig.graphMeEndpoint, options)
            .then(response => response.json())
            .catch(error => console.log(error))
    }
}

export class COSMOS_API extends API {
    protected static API_ENDPOINT = AppEnvSetting.cosmosapi;

    static POST =  async (body: any, endpointName: POST_ENDPOINT, token: Promise<string | undefined>, logging = false): Promise<{ok: boolean, status: number, respBody: any}> => {
        return await API.POST_API(body, endpointName, token, COSMOS_API.API_ENDPOINT, logging);
    }

    static GET =  async (endpointName: GET_ENDPOINT, token: Promise<string | undefined>, logging = false): Promise<{ok: boolean, status: number, respBody: any}> => {
        return await API.GET_API(endpointName, token, COSMOS_API.API_ENDPOINT, logging);
    }
}

export class EXTERNAL_API extends API {
    protected static API_ENDPOINT = AppEnvSetting.externalapi;

    static POST =  async (body: any, endpointName: POST_ENDPOINT, token: Promise<string | undefined>, logging = false): Promise<{ok: boolean, status: number, respBody: any}> => {
        return await API.POST_API(body, endpointName, token, EXTERNAL_API.API_ENDPOINT, logging);
    }

    static GET =  async (endpointName: GET_ENDPOINT, token: Promise<string | undefined>, logging = false): Promise<{ok: boolean, status: number, respBody: any}> => {
        return await API.GET_API(endpointName, token, EXTERNAL_API.API_ENDPOINT, logging);
    }
}

export class IEF_API extends API {
  protected static API_ENDPOINT = AppEnvSetting.iefapi;

  static POST =  async (body: any, endpointName: IEF_API_POST_ENDPOINT, token: Promise<string | undefined>, logging = false): Promise<{ok: boolean, status: number, respBody: any}> => {
      return await API.POST_API(body, endpointName, token, IEF_API.API_ENDPOINT, logging);
  }

  static DELETE =  async (body: any, endpointName: IEF_API_POST_ENDPOINT, token: Promise<string | undefined>, logging = false): Promise<{ok: boolean, status: number, respBody: any}> => {
    return await API.DELETE_API(body, endpointName, token, IEF_API.API_ENDPOINT, logging);
  }

  static GET =  async (endpointName: IEF_API_GET_ENDPOINT, token: Promise<string | undefined>, logging = false): Promise<{ok: boolean, status: number, respBody: any}> => {
      return await API.GET_API(endpointName, token, IEF_API.API_ENDPOINT, logging);
  }
}

export { GET_ENDPOINT, POST_ENDPOINT, IEF_API_POST_ENDPOINT, IEF_API_GET_ENDPOINT};